// extracted by mini-css-extract-plugin
export default {"container":"style_container__7ZFNf","tabsToggles":"style_tabsToggles__rzCZd","tabsContent":"style_tabsContent__fqudl","required":"style_required__ZtwSI"};